export class UserRole {
    user_role_id ?= '';
    user_role ?= '';
    user_role_level ?= '';
    user_role_status ?= '';
}


// WEBPACK FOOTER //
// ./src/app/type/user-role.ts